module.exports = __webpack_public_path__ + "img/article_9_1.e628d170.png";